import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Loader from '../components/common/loader';

// Since we don't have a dedicated API endpoint for all brands,
// we'll use a hard-coded list for now and display it nicely
const Brands = () => {
  const [loading, setLoading] = useState(true);
  
  // This would ideally come from an API
  const brands = [
    { 
      id: 'faber-castell', 
      name: 'Faber-Castell', 
      description: 'One of the world\'s largest manufacturers of pens, pencils, other office supplies and art supplies.',
      logo: '/images/brands/faber-castell.png',
      productCount: 24
    },
    { 
      id: 'staedtler', 
      name: 'Staedtler', 
      description: 'A German manufacturer of writing instruments, drawing and art supplies.',
      logo: '/images/brands/staedtler.png',
      productCount: 18
    },
    { 
      id: 'pilot', 
      name: 'Pilot', 
      description: 'A Japanese manufacturer of writing instruments, known for their high-quality pens.',
      logo: '/images/brands/pilot.png',
      productCount: 15
    },
    { 
      id: 'moleskine', 
      name: 'Moleskine', 
      description: 'Italian manufacturer and designer of luxury notebooks, planners, diaries, and more.',
      logo: '/images/brands/moleskine.png',
      productCount: 12
    },
    { 
      id: 'leuchtturm1917', 
      name: 'Leuchtturm1917', 
      description: 'German manufacturer of high-quality notebooks, planners and accessories.',
      logo: '/images/brands/leuchtturm1917.png',
      productCount: 10
    },
    { 
      id: 'tombow', 
      name: 'Tombow', 
      description: 'Japanese manufacturer of writing instruments and art supplies.',
      logo: '/images/brands/tombow.png',
      productCount: 14
    },
    { 
      id: 'sakura', 
      name: 'Sakura', 
      description: 'Japanese company known for their gel pens, markers, and art supplies.',
      logo: '/images/brands/sakura.png',
      productCount: 16
    },
    { 
      id: 'pentel', 
      name: 'Pentel', 
      description: 'Japanese manufacturer of stationery products including pens, mechanical pencils and more.',
      logo: '/images/brands/pentel.png',
      productCount: 20
    }
  ];

  useEffect(() => {
    // Simulate loading
    const timer = setTimeout(() => {
      setLoading(false);
    }, 800);
    
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="container mx-auto px-4 py-8">
      <div className="mb-6">
        <h1 className="text-2xl font-bold">Shop by Brands</h1>
        <p className="text-gray-600">Discover premium stationery from top brands around the world</p>
      </div>
      
      {loading ? (
        <div className="flex justify-center items-center h-64">
          <Loader size="lg" />
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {brands.map((brand) => (
            <Link 
              key={brand.id} 
              to={`/brand/${brand.id}`}
              className="block group"
            >
              <div className="bg-white rounded-lg shadow-md p-6 hover:shadow-lg transition duration-300 flex flex-col sm:flex-row gap-4 items-center">
                <div className="w-24 h-24 flex items-center justify-center bg-gray-50 rounded-lg p-2 border">
                  {/* In a real app, you would use the actual logo */}
                  {brand.logo ? (
                    <img 
                      src={brand.logo}
                      alt={brand.name}
                      className="max-w-full max-h-full"
                    />
                  ) : (
                    <div className="text-3xl font-bold text-gray-300">
                      {brand.name.charAt(0)}
                    </div>
                  )}
                </div>
                
                <div className="flex-1 text-center sm:text-left">
                  <h3 className="text-lg font-semibold mb-1 group-hover:text-blue-600 transition-colors">
                    {brand.name}
                  </h3>
                  
                  <p className="text-gray-600 text-sm mb-2">
                    {brand.description}
                  </p>
                  
                  <span className="inline-block bg-blue-50 text-blue-600 text-xs px-2 py-1 rounded-full">
                    {brand.productCount} {brand.productCount === 1 ? 'product' : 'products'}
                  </span>
                </div>
                
                <div className="text-blue-600 group-hover:underline text-sm font-medium self-end sm:self-center">
                  View Products →
                </div>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
};

export default Brands;